import { Tag } from '@cian/components';
import * as React from 'react';
import { IPhoneTag } from '../../../state/tags/definitions/phone';
import { TagNew } from '../TagNew';

import { tagThemeSmall } from '../tag_theme';

export interface IPhoneTagItemProps {
  tag: IPhoneTag;
  withNewTag?: boolean;
  onDeleteClick(): void;
}

export const PhoneTagItem = ({ withNewTag, onDeleteClick, tag }: IPhoneTagItemProps) => {
  const TagComponent = React.useMemo(() => (withNewTag ? TagNew : Tag), [withNewTag]);

  return (
    <TagComponent onDeleteClick={onDeleteClick} tagStyles={tagThemeSmall}>
      Телефон {tag.value}
    </TagComponent>
  );
};
